// tileCatalog — единен каталог на модулните плочки.
// Ползва се от ModuleShortcutTiles (пълния ред) и от PinnedTilesRow
// (закачените до 4 любими плочки в началото на dashboard-а).

import { moduleTitle } from "@/lib/twinCatalog";

export const TILE_CATALOG = [
  {
    id: "plate-sim",
    emoji: "🍽️",
    title_bg: "Симулатор на чинията",
    title_en: "Plate Simulator",
    sub_bg: "Дневник · заснемете ястието и вижте DIL и NIS веднага",
    sub_en: "Diary · scan a meal and see DIL & NIS live",
    path: "/dashboard/diary",
    gradient: "from-emerald-500/15 to-teal-500/15",
    border: "border-emerald-500/30",
    shortcut: true,
  },
  {
    id: "bhi",
    emoji: "🎗️",
    title_bg: moduleTitle("bhi"),
    title_en: "Breast Health Intelligence",
    sub_bg: "Плътност · естрогенно доминиране · DUTCH · BDI",
    sub_en: "Density · estrogen dominance · DUTCH · BDI",
    path: "/health-intelligence/breast",
    gradient: "from-pink-500/15 to-rose-500/15",
    border: "border-pink-500/30",
    shortcut: true,
  },
  {
    id: "cortisol",
    emoji: "🌗",
    title_bg: moduleTitle("cortisol"),
    title_en: "Cortisol Intelligence",
    sub_bg: "Ритъм · 28-дневна програма · дишане · вечерен ритуал",
    sub_en: "Rhythm · 28-day program · breathing · evening ritual",
    path: "/dashboard/stress-twin",
    gradient: "from-amber-500/15 to-orange-500/15",
    border: "border-amber-500/30",
    shortcut: true,
  },
  {
    id: "dhi",
    emoji: "🦷",
    title_bg: moduleTitle("dhi"),
    title_en: "Dental Health Intelligence",
    sub_bg: "Защита на зъбите · перио · орално-системна връзка",
    sub_en: "Tooth protection · perio · oral-systemic link",
    path: "/health-intelligence/dental",
    gradient: "from-cyan-500/15 to-blue-500/15",
    border: "border-cyan-500/30",
    shortcut: true,
  },
  {
    id: "twins-network",
    emoji: "🕸️",
    title_bg: "Жива мрежа на близнаците",
    title_en: "Living Twin Network",
    sub_bg: "20 близнака · карта на връзките в реално време",
    sub_en: "22 twins · live connection graph",
    path: "/twins/network",
    gradient: "from-indigo-500/15 to-violet-500/15",
    border: "border-indigo-500/30",
    shortcut: true,
  },
  {
    id: "phenotype-explorer",
    emoji: "🔬",
    title_bg: "Наследствени профили",
    title_en: "Phenotype Explorer",
    sub_bg: "над 40 фенотипа · пътища по KEGG · тъкани · близнаци · сравнение",
    sub_en: "40+ phenotypes · KEGG pathways · tissues · compare",
    path: "/phenotype-explorer",
    gradient: "from-fuchsia-500/15 to-purple-500/15",
    border: "border-fuchsia-500/30",
    shortcut: true,
  },
  {
    id: "intervention-simulator",
    emoji: "🌿",
    title_bg: "Симулатор на въздействията",
    title_en: "Intervention Simulator",
    sub_bg: "Храни · съединения · тяло и ум — по данни от Nutramilo и USDA",
    sub_en: "Foods · compounds · mind-body — Nutramilo/USDA resolved",
    path: "/intervention-simulator",
    gradient: "from-emerald-500/15 to-teal-500/15",
    border: "border-emerald-500/30",
    shortcut: true,
  },
  {
    id: "pathway-vault",
    emoji: "🏦",
    title_bg: "Хранилище на пътищата и личен план",
    title_en: "Pathway Vault + Personal Plan",
    sub_bg: "Централно хранилище на Вашите пътища и 4-седмичен план с отметки",
    sub_en: "Your pathway vault + 4-week plan with checklist",
    path: "/pathway-vault",
    gradient: "from-fuchsia-500/15 to-violet-500/15",
    border: "border-fuchsia-500/30",
    shortcut: true,
  },
  // ── Допълнителни цели, достъпни само за закачане ──
  {
    id: "khi",
    emoji: "🫘",
    title_bg: moduleTitle("khi"),
    title_en: "Kidney Health Intelligence",
    sub_bg: "Скорост на филтрация · граници по KDIGO · калий и фосфор · дневник на диализата",
    sub_en: "eGFR · KDIGO limits · K/P · dialysis log",
    path: "/dashboard/kidney-intelligence",
    gradient: "from-cyan-500/15 to-sky-500/15",
    border: "border-cyan-500/30",
  },
  {
    id: "labs",
    emoji: "🧪",
    title_bg: "Лаборатории и анализи",
    title_en: "Labs & analyses",
    sub_bg: "Централният раздел — качване, показатели, автоматично разчитане",
    sub_en: "The central module — upload, markers, auto-diagnosis",
    path: "/dashboard/analyses",
    gradient: "from-sky-500/15 to-blue-500/15",
    border: "border-sky-500/30",
  },
  {
    id: "nutrition-lab",
    emoji: "🥗",
    title_bg: "Хранителна лаборатория",
    title_en: "Nutrition Lab",
    sub_bg: "DIL бюджет · хранителен профил · ястия",
    sub_en: "DIL budget · nutrition profile · meals",
    path: "/dashboard/nutrition-lab",
    gradient: "from-emerald-500/15 to-lime-500/15",
    border: "border-emerald-500/30",
  },
  {
    id: "mindbody-lab",
    emoji: "🧠",
    title_bg: "Ум и тяло",
    title_en: "Mind & Body Lab",
    sub_bg: "Напрежение · сън · ритуали · дишане",
    sub_en: "Stress · sleep · rituals · breathing",
    path: "/dashboard/mindbody-lab",
    gradient: "from-violet-500/15 to-indigo-500/15",
    border: "border-violet-500/30",
  },
  {
    id: "my-menus",
    emoji: "📋",
    title_bg: "Моите менюта",
    title_en: "My menus",
    sub_bg: "Седмични менюта и планове, изготвени за Вас",
    sub_en: "Weekly menus and plans generated for you",
    path: "/dashboard/my-menus",
    gradient: "from-amber-500/15 to-orange-500/15",
    border: "border-amber-500/30",
  },
  {
    id: "medications",
    emoji: "💊",
    title_bg: "Лекарства и добавки",
    title_en: "Medications & supplements",
    sub_bg: "Проверка за взаимодействия (KDIGO + FDA листовки)",
    sub_en: "Interaction check (KDIGO + FDA labels)",
    path: "/dashboard/medications",
    gradient: "from-violet-500/15 to-fuchsia-500/15",
    border: "border-violet-500/30",
  },
  {
    id: "health-intelligence",
    emoji: "🩺",
    title_bg: "Здравни раздели и проверки",
    title_en: "Health Intelligence",
    sub_bg: "Всички раздели по органи и кратки проверки на едно място",
    sub_en: "All organ modules and screenings in one place",
    path: "/dashboard/health-intelligence",
    gradient: "from-rose-500/15 to-pink-500/15",
    border: "border-rose-500/30",
  },
];

export const getTile = (id) => TILE_CATALOG.find((t) => t.id === id) || null;
export const DEFAULT_PINS = ["labs", "plate-sim", "bhi", "khi"];
